
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#9B51E0"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-width":"1.5","d":"M18 19.5l2 2 4.5-4.5"}}),_c('mask',{attrs:{"id":"ll0xydi29a","fill":"#fff"}},[_c('rect',{attrs:{"width":"14","height":"14","x":"14","y":"12","rx":"1"}})]),_c('rect',{attrs:{"width":"14","height":"14","x":"14","y":"12","stroke":"#fff","stroke-width":"3","mask":"url(#ll0xydi29a)","rx":"1"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-width":"1.5","d":"M12 18v9a1 1 0 001 1h8"}})])
          )
        }
      }
    